export function isTouch() {
  return 'ontouchstart' in document.documentElement
}

export function checkFavorite(productId, favorites) {
  if (favorites) {
    return productId in favorites
  }

  return false
}

export const colors = {
  ACCENT: 'accent-color',
  AMBER: 'amber',
  CORAL: 'coral',
  CORAL_DARK: 'coral-dark',
  CORAL_LIGHT: 'coral-light',
  ERROR: 'error-color',
  FONT_ACCENT: 'font-accent-color',
  FONT: 'font-color',
  FONT_INVERTED: 'font-inverted-color',
  GREEN: 'green',
  GREY_DARK: 'grey-dark',
  GREY_LIGHT: 'grey-light',
  GREY_MEDIUM: 'grey-medium',
  GREY_ULTRA_DARK: 'grey-ultra-dark',
  GREY_ULTRA_LIGHT: 'grey-ultra-light',
  LINK: 'link-color',
  LINK_HOVER: 'link-hover-color',
  SUCCESS: 'success-color',
  WARNING: 'warning-color',
  WHITE: 'white',
}

export function isValidEmail(email) {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}
